/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPCONTACTFORINFO = {
    Client: 'Client',
    Intermediary: 'Intermediary',
    Other: 'Other'
} as const;
export type IAPCONTACTFORINFO = typeof IAPCONTACTFORINFO[keyof typeof IAPCONTACTFORINFO];


export function IAPCONTACTFORINFOFromJSON(json: any): IAPCONTACTFORINFO {
    return IAPCONTACTFORINFOFromJSONTyped(json, false);
}

export function IAPCONTACTFORINFOFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPCONTACTFORINFO {
    return json as IAPCONTACTFORINFO;
}

export function IAPCONTACTFORINFOToJSON(value?: IAPCONTACTFORINFO | null): any {
    return value as any;
}

